import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { AssetsComponent } from './components/assets/assets.component';
import { AssetDetailsComponent } from './components/asset-details/asset-details.component';
import { FaqComponent } from './components/faq/faq.component';
import { HomeComponent } from './components/home/home.component';
import { MyBookmarksComponent } from './components/my-bookmarks/my-bookmarks.component';
import { MsalGuard } from '@azure/msal-angular';

const routes: Routes = [
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'asset-home',
    component: AssetsComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'assetdetails/:asset_id',
    component: AssetDetailsComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'faq',
    component: FaqComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'mybookmarks',
    component: MyBookmarksComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'contribute',
    loadChildren: () =>
      import("./components/contribute/contribute.module").then((m) => m.ContributeModule),
    canActivate: [MsalGuard]
  },
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: '**', redirectTo: '/home', pathMatch: 'full' },
];

const config: ExtraOptions = {
  useHash: true,
};
@NgModule({
  imports: [RouterModule.forRoot(routes,
  { onSameUrlNavigation: 'reload', scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
